module.exports = __webpack_public_path__ + "static/media/Liepard_gaussian2.a38b2c57.png";